import { ReactNode } from 'react';
import classnames from 'classnames';
import './style.scss';

interface IPaperProps {
  children: ReactNode;
  className?: string;
}

const Paper = ({ children, className }: IPaperProps) => {
  const paperClass = classnames('paper', className);
  return <div className={paperClass}>{children}</div>;
};

export default Paper;
